/**
 * IPC contract shared by Electron main (`desktop/browser-login.ts`),
 * preload, and the renderer auth module.
 */

export const BROWSER_LOGIN_CANCELLED_ERROR = "Login cancelled" as const;

export const AUTH0_SPA_STORAGE_KEY_PREFIX = "a0.spajs." as const;
export const AUTH0_SPA_TRANSACTION_KEY_PREFIX =
	`${AUTH0_SPA_STORAGE_KEY_PREFIX}txs.` as const;

export type BrowserLoginCallbackPayload =
	| { ok: true; url: string }
	| { ok: false; error: string };

export function auth0SpaTransactionStorageKey(clientId: string): string {
	return `${AUTH0_SPA_TRANSACTION_KEY_PREFIX}${clientId}`;
}
